import { ROLES } from "utils/helpers/enums/roles.enum";
import { INDUSTRY_TYPES, USER_STATUSES } from "utils/helpers/enums/shared.enum";

export class BusinessFiltersDTO {
  page: number = 1;
  limit: number = 10;
  count: number = 1;
  size: number = 10;
  nameOrEmail: string = "";
  city: string = "";
  status: USER_STATUSES;
  industry: INDUSTRY_TYPES;
  searchTitle: string = "";
}
